import { DirectCounterDto, DirectMetricsUI } from '../../data-layer/direct/types';

export const toMetricsUI = (metrics: DirectCounterDto[]): DirectMetricsUI =>
    metrics.reduce<DirectMetricsUI>(
        (result, counter) => {
            const goals = counter.goals ?? [];
            const counterId = counter.counter_id;

            result.counters.push({
                id: counterId,
                domain: counter.domain,
                goals: goals.map((goal) => goal.goal_id),
            });

            result.goals.push(
                ...goals.map((goal) => ({
                    counterId,
                    id: goal.goal_id,
                    name: goal.name,
                })),
            );

            return result;
        },
        { counters: [], goals: [] },
    );
